import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "h-100"
}
const _hoisted_2 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppGlobalModal = _resolveComponent("AppGlobalModal")!
  const _component_UserToolbar = _resolveComponent("UserToolbar")!
  const _component_AlertModal = _resolveComponent("AlertModal")!
  const _component_AppLayout = _resolveComponent("AppLayout")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_BeforeLoginLayout = _resolveComponent("BeforeLoginLayout")!
  const _component_message_modal = _resolveComponent("message-modal")!

  return (_ctx.isLoaded)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createVNode(_component_AppGlobalModal),
        _createVNode(_component_UserToolbar),
        (_ctx.showAlert)
          ? (_openBlock(), _createBlock(_component_AlertModal, {
              key: 0,
              content: _ctx.content,
              closeModal: _ctx.closeTutorialModal
            }, null, 8, ["content", "closeModal"]))
          : _createCommentVNode("", true),
        (_ctx.isPortalChrome && _ctx.isLoggedIn && !(_ctx.gigICode && _ctx.gigIvToken) && _ctx.isMounted)
          ? (_openBlock(), _createBlock(_component_AppLayout, { key: 1 }))
          : (_ctx.isPortalChrome && !_ctx.isLoggedIn && _ctx.isMounted)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_BeforeLoginLayout, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_view, null, {
                      default: _withCtx(({ Component }) => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["main-view", _ctx.getBGClass()])
                        }, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                        ], 2)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]))
            : (_ctx.isMounted)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_AppLayout)
                ]))
              : _createCommentVNode("", true),
        (_ctx.openModal)
          ? (_openBlock(), _createBlock(_component_message_modal, {
              key: 4,
              message: _ctx.message,
              subMessage: _ctx.subMessage,
              isErrorModal: _ctx.isErrorModal,
              onClose: _cache[0] || (_cache[0] = 
        () => {
          _ctx.openModal = false
        }
      )
            }, null, 8, ["message", "subMessage", "isErrorModal"]))
          : _createCommentVNode("", true)
      ], 64))
    : _createCommentVNode("", true)
}